// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"12":"f5bc65ad","388":"8dc2e803","423":"7812caf1","668":"bec0cd1e","951":"3bcd9b10"}[chunkId] + ".css";
};